import { render, staticRenderFns } from "./Banners.vue?vue&type=template&id=2d411bde&scoped=true&lang=pug&"
import script from "./Banners.vue?vue&type=script&lang=js&"
export * from "./Banners.vue?vue&type=script&lang=js&"
import style0 from "./Banners.styl?vue&type=style&index=0&id=2d411bde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d411bde",
  null
  
)

export default component.exports